export default __webpack_public_path__ + "static/media/arrow-with-border.d098f94c.svg";